// Comparação entre os dados preenchidos numa tela e o que já está no cadastro de Clientes/Veículos.
// Funções puras, sem I/O — as buscas ficam em cadastroSync.js, que reexporta estas para quem já as usava.

const apenasDigitos = (v) => (v || '').toString().replace(/\D/g, '');

// Normaliza para comparar com o cadastro: CPF/CNPJ só dígitos; UF, chassi e nº do motor em maiúsculas
// (é assim que o backend os grava, senão digitar em minúsculas apareceria como "diferente do cadastro");
// sem espaços nas pontas.
// A placa ainda ignora o hífen: o sistema grava AAA-0A00, mas há cadastros antigos sem ele, e ABC-1D23
// e ABC1D23 são a mesma placa — apontá-las como diferentes seria um alarme falso.
export function normalizar(campo, valor) {
  const v = (valor ?? '').toString().trim();
  if (campo === 'cpfCnpj') return apenasDigitos(v);
  if (campo === 'placa') return v.toUpperCase().replace(/[^A-Z0-9]/g, '');
  if (['uf', 'chassi', 'motor'].includes(campo)) return v.toUpperCase();
  return v;
}

// Campos preenchidos na tela que são novos ou diferentes do cadastro. Campo em branco não conta (não apaga nada).
export function camposDiferentes(atual, origem, campos) {
  return campos.filter((c) => {
    const novo = normalizar(c, atual[c]);
    return novo !== '' && novo !== normalizar(c, origem ? origem[c] : '');
  });
}

// Situação dos dados em relação ao cadastro: 'vazio' | 'novo' | 'alterado' | 'igual' | 'desconhecido'
export function situacaoCadastro({ vinculado, origem, atual, campos, obrigatorios, rotuloNovo, camposFixos = [], rotulosCampo = {} }) {
  if (!vinculado) {
    const completo = obrigatorios.every((c) => normalizar(c, atual[c]) !== '');
    return completo ? { tipo: 'novo', texto: rotuloNovo } : { tipo: 'vazio', texto: 'Preencha os dados para poder salvá-los no cadastro.' };
  }
  if (!origem) return { tipo: 'desconhecido', texto: 'Atualiza o cadastro com os dados preenchidos aqui (campos em branco não apagam nada).' };
  const diferentes = camposDiferentes(atual, origem, campos.filter((c) => !camposFixos.includes(c)));
  if (diferentes.length === 0) return { tipo: 'igual', texto: 'Dados iguais aos do cadastro.' };
  return { tipo: 'alterado', texto: `Novo ou diferente do cadastro: ${diferentes.map((c) => rotulosCampo[c] || c).join(', ')}.` };
}
